import React from "react";
import IconEnviado from "../componentsStyled/icon/Iconenviado";
import { DataFollow } from "./Types";
import { Box, Button, Modal } from "@mui/material";
interface ModalRealizadoProps {
  isOpen?: boolean;
  children?: React.ReactNode;
  onRequestClose?: () => void;
  data?: DataFollow;
}

const ModalRealizado: React.FC<ModalRealizadoProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 1,
        width: 300,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box>
        <IconEnviado width={60} />
        <Box marginY={2}>
          <p>
            <strong className="blue">Solicitação</strong>&nbsp;Realizada!
          </p>
        </Box>
        <Box marginY={2}>
          <p>Sua solicitação já foi enviada e está em análise. Aguarde o retorno do SAC para dar continuidade ao processo.</p>
        </Box>

        <Button onClick={onRequestClose}>Voltar</Button>
      </Box>
    </Modal>
  );
};

export default ModalRealizado;
